import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Loader } from '@parchment/atoms';
import { Document, options } from '../../utils/ReactPdf';
import PageList from '../PageList';

var PdfDocument = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(PdfDocument, _React$PureComponent);

  function PdfDocument() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      document: null
    });

    _defineProperty(_assertThisInitialized(_this), "handleDocumentLoaded", function (document) {
      _this.setState({
        document: document
      });

      _this.props.onLoad && _this.props.onLoad(document);
    });

    _defineProperty(_assertThisInitialized(_this), "handleContextMenu", function (e) {
      // when blockRightClick is set we want to prevent default and return false
      return !(_this.props.blockRightClick && (e.preventDefault() || true));
    });

    return _this;
  }

  var _proto = PdfDocument.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var document = this.state.document;
    var _this$props = this.props,
        file = _this$props.file,
        scale = _this$props.scale,
        fitTo = _this$props.fitTo,
        onPageChange = _this$props.onPageChange,
        isModal = _this$props.isModal;
    return /*#__PURE__*/React.createElement(DocumentContainer, {
      onContextMenu: this.handleContextMenu,
      isModal: isModal
    }, /*#__PURE__*/React.createElement(Document, {
      file: file,
      loading: /*#__PURE__*/React.createElement(Loader, {
        loading: true
      }),
      onLoadSuccess: this.handleDocumentLoaded,
      inputRef: function inputRef(e) {
        return _this2.container = e;
      },
      options: options
    }, /*#__PURE__*/React.createElement(PageList, {
      container: this.container,
      pageCount: document && document.numPages,
      scale: scale,
      fitTo: fitTo,
      onPageChange: onPageChange
    })));
  };

  return PdfDocument;
}(React.PureComponent);

_defineProperty(PdfDocument, "propTypes", {
  file: PropTypes.string.isRequired,
  scale: PropTypes.number,
  fitTo: PropTypes.oneOf(['page', 'width']),
  onLoad: PropTypes.func,
  onPageChange: PropTypes.func,

  /**
   * Whether or not right click is allowed
   */
  blockRightClick: PropTypes.bool,
  isModal: PropTypes.bool
});

_defineProperty(PdfDocument, "defaultProps", {
  scale: 1,
  fitTo: 'page'
});

export { PdfDocument as default };
var DocumentContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "PdfDocument__DocumentContainer",
  componentId: "sc-1yh6fd8-0"
})(["", " width:100%;height:100%;padding:22px 0;overflow:auto;.react-pdf__message{background:white;padding:3em;margin:22px auto;max-width:100%;width:768px;}.react-pdf__Document{height:100%;}"], function (_ref) {
  var isModal = _ref.isModal;
  return isModal && 'position: absolute; left: 0; top: 0;';
});
DocumentContainer.displayName = 'DocumentContainer';